module.exports = __webpack_public_path__ + "static/media/cat-space.30acbca8.svg";